import {
  PROFILE_BANNER_ASPECT_HEIGHT,
  PROFILE_BANNER_ASPECT_WIDTH,
} from '@/features/profile/constants';

export type ProfileImageCropTarget = 'avatar' | 'banner';

export interface ProfileImageCropPreset {
  readonly target: ProfileImageCropTarget;
  readonly title: string;
  readonly aspect: number;
  readonly cropShape: 'rect' | 'round';
  readonly outputWidth: number;
  readonly outputHeight: number;
  /** Cropper viewport — tall for wide banners so the image is not tiny. */
  readonly cropViewportClassName: string;
  readonly modalClassName: string;
  readonly objectFit: 'contain' | 'cover' | 'horizontal-cover' | 'vertical-cover';
  readonly minZoom: number;
  readonly maxZoom: number;
}

export const PROFILE_AVATAR_CROP_PRESET: ProfileImageCropPreset = {
  target: 'avatar',
  title: 'Crop profile photo',
  aspect: 1,
  cropShape: 'round',
  outputWidth: 400,
  outputHeight: 400,
  cropViewportClassName: 'aspect-square w-full max-h-[min(72vw,22rem)]',
  modalClassName: 'max-w-md',
  objectFit: 'contain',
  minZoom: 1,
  maxZoom: 3,
};

export const PROFILE_BANNER_CROP_PRESET: ProfileImageCropPreset = {
  target: 'banner',
  title: 'Crop background image',
  aspect: PROFILE_BANNER_ASPECT_WIDTH / PROFILE_BANNER_ASPECT_HEIGHT,
  cropShape: 'rect',
  outputWidth: 1200,
  outputHeight: 300,
  /** Tall viewport; crop window stays 4:1 but image can fill the area. */
  cropViewportClassName: 'h-[min(52vh,20rem)] w-full min-h-[16rem] sm:h-[22rem]',
  modalClassName: 'max-w-3xl',
  objectFit: 'horizontal-cover',
  minZoom: 1,
  maxZoom: 5,
};

export function getProfileImageCropPreset(target: ProfileImageCropTarget): ProfileImageCropPreset {
  return target === 'avatar' ? PROFILE_AVATAR_CROP_PRESET : PROFILE_BANNER_CROP_PRESET;
}
